export const CODE = {
  List: '/codes',
};
